const dummyStocks = [
  {
    name: "Reliance Industries",
    nseCode: "RELIANCE",
    bseCode: "500325",
    sector: "Oil & Gas",
  },
  {
    name: "Tata Consultancy Services",
    nseCode: "TCS",
    bseCode: "532540",
    sector: "IT",
  },
  {
    name: "HDFC Bank",
    nseCode: "HDFCBANK",
    bseCode: "500180",
    sector: "Banking",
  },
  { name: "Infosys", nseCode: "INFY", bseCode: "500209", sector: "IT" },
  {
    name: "ICICI Bank",
    nseCode: "ICICIBANK",
    bseCode: "532174",
    sector: "Banking",
  },
  {
    name: "State Bank of India",
    nseCode: "SBIN",
    bseCode: "500112",
    sector: "Banking",
  },
  {
    name: "Bharti Airtel",
    nseCode: "BHARTIARTL",
    bseCode: "532454",
    sector: "Telecom",
  },
  {
    name: "Larsen & Toubro",
    nseCode: "LT",
    bseCode: "500510",
    sector: "Engineering",
  },
  {
    name: "Maruti Suzuki",
    nseCode: "MARUTI",
    bseCode: "532500",
    sector: "Automobile",
  },
  {
    name: "Hindustan Unilever",
    nseCode: "HINDUNILVR",
    bseCode: "500696",
    sector: "FMCG",
  },
]

export default dummyStocks
